
import { MealCard } from "./MealCard";

interface MealCategoryProps {
  title: string;
  meals: any[];
}

export const MealCategory = ({ title, meals }: MealCategoryProps) => {
  if (!meals || meals.length === 0) return null;

  return (
    <div className="py-4 MealCategory">
      <h2 className="text-xl font-semibold mb-4 px-4">{title}</h2>
      <div className="relative">
        <div className="overflow-x-auto scrollbar-hide">
          <div className="flex gap-4 pb-4 px-4 w-max">
            {meals.map((meal) => {
              // Ensure chef object exists with proper type safety
              const chef = meal.chef || {};
              
              // Get first and last name, with fallbacks
              const firstName = chef.first_name || "";
              const lastName = chef.last_name || "";
              
              // Construct chef name with fallback
              const chefName = (firstName || lastName) 
                ? `${firstName} ${lastName}`.trim() 
                : 'Anonymous Chef';
              
              // Debug log for chef name handling
              console.log(`MealCategory ${title}: Meal "${meal.name}" chef: "${chefName}", raw chef data:`, chef);
              
              // Ensure preparation_type is a valid value
              const preparationType = (meal.preparation_type === "on_demand" ? "on_demand" : "scheduled") as "on_demand" | "scheduled";
              
              return (
                <div key={meal.id} className="w-[240px] shrink-0">
                  <MealCard
                    id={meal.id}
                    name={meal.name}
                    image={meal.image || "https://via.placeholder.com/400x300"}
                    rating={Number(meal.rating) || 0}
                    reviews={meal.reviews_count || 0}
                    distance={meal.distance || "Distance unavailable"}
                    price={Number(meal.price)}
                    availabilitySlots={meal.availability_slots || []}
                    chefName={chefName}
                    preparationType={preparationType}
                    prepTimeHours={meal.prep_time_hours}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
